var _module = require('../../components/module.js');
var config = require('config');
var moment = require('moment');
var _ = require('lodash');

require('../user');
require('../login-or-register-modal');
require('../verify-modal');

_module.service('srUtils', [
    '$log',
    '$filter',
    '$window',
    '$state',
    '$user',
    '$loginOrRegisterModal',
    '$verifyModal',
    'localStorageService',
    '$q',

    function srUtils($log, $filter, $window, $state, $user, $loginOrRegisterModal, $verifyModal, localStorageService, $q) {
        return {
            isMobile: function () {
                var breakpoint = 960;
                var w = $window.innerWidth;
                return (w <= breakpoint);
            },

            detailViewAccess: function (usr) {
                if(usr.account_type == 'verified'){
                    return true;
                }else{
                    var viewCount = localStorageService.get('userDetailViewCount');
                    if(viewCount == null || angular.isUndefined(viewCount)){
                        localStorageService.set('userDetailViewCount', 1);
                        return true;
                    } else if(!isNaN(viewCount) && parseInt(viewCount, 10) < 5){
                        viewCount += 1;
                        localStorageService.set('userDetailViewCount', viewCount);
                        return true;
                    } else{
                        return false;
                    }
                }
            },

            getDetailViewUrl: function (params) {
                return $state.href('viewlisting', params);
            },

            openDetailView: function (params) {
                var hasAccess = this.detailViewAccess($user);

                if(hasAccess) {
                    $state.go('viewlisting', params);
                }else{
                    switch($user.account_type) {
                        case 'unverified': $verifyModal();
                            break;
                        default: $loginOrRegisterModal();
                    }
                }
            },

            getListHeightOffset: function (layout) {
                var listHeightOffset = 0;
                angular.forEach(layout || {}, function (val, key) {
                    if(!isNaN(val)){
                        listHeightOffset += Math.abs(parseInt(val, 10));
                    }
                });
                return (listHeightOffset)
                            ? '-' + listHeightOffset
                            : undefined;
            },

            getHeroImageUrl: function (data) {
                var _this = this;
                var imgUrl = ['/v1/listings/', data.id, '/heroimage'].join('');
                return imgUrl;
            },

            getFallbackHeroImageUrl: function (data) {
                var heroImage;
                if(!!data.Photos && angular.isArray(data.Photos) && data.Photos.length){
                    heroImage = data.Photos[0].MediaURL;
                } else{
                    var basePath = 'https://maps.googleapis.com/maps/api/staticmap?';
                    heroImage = basePath;
                    //heroImage += 'center=' + data.lat + ',' + data.lon;
                    heroImage += 'center=33.786704,-117.853425'; //hardcoded for dev
                    heroImage += '&zoom=17&maptype=satellite&size=500x320';
                    //heroImage += '&key=' + config.google.apiKey;


                    heroImage = '/images/search-results/hero_placeholder.png';
                }

                return heroImage;
            },

            getMedian: function (values) {
                values.sort( function(a,b) {return a - b;} );
                var half = Math.floor(values.length/2);
                if(values.length % 2)
                    return values[half];
                else
                    return (values[half-1] + values[half]) / 2.0;
            },

            getMapCenter: function (results) {
                var latArr = [];
                var lonArr = [];
                results.forEach(function (listing, i) {
                    latArr.push(listing.lat);
                    lonArr.push(Math.abs(listing.lon));
                }, results);

                var medianLat = this.getMedian(latArr);
                var medianLon = -1 * this.getMedian(lonArr);

                return {
                    latitude: medianLat,
                    longitude: medianLon
                };

            },

            getUserLocation: function () {
                return $q(function (resolve, reject) {
                    if(navigator && navigator.geolocation) {
                        var loc = null;

                        var onSuccess = function (position) {
                            if(position && position.coords) {
                                loc = position.coords;
                                $log.debug('Got user\'s current location', position);
                            }
                            return resolve(loc);
                        };

                        var onError = function (error) {
                            var msg = 'Sorry! An unknown error occurred. Please try again or contact support@listreports.com if this persists.';

                            if (error && error.code) {
                                switch (error.code){
                                    case error.PERMISSION_DENIED:
                                        msg = 'Sorry! It looks like you previously denied the Geolocation capability. For information on reenabling this feature, visit this link: https://support.google.com/chrome/answer/142065?hl=en';
                                        break;
                                    case error.POSITION_UNAVAILABLE:
                                        msg = 'Sorry! Your position is currently unavailable.';
                                        break;
                                    case error.PERMISSION_DENIED_TIMEOUT:
                                        msg = 'Timeout! Sorry, it took too long to grant/deny permission to access your location.';
                                        break;
                                    case error.UNKNOWN_ERROR:
                                    default:
                                        msg = 'Sorry! An unknown error occurred. Please try again or contact support@listreports.com if this persists.';
                                        break;
                                }
                                $log.debug(msg);
                            }

                            return reject(msg);
                        };

                        navigator.geolocation.getCurrentPosition(
                            onSuccess,
                            onError,
                            { maximumAge:300000, timeout: 120000 }
                        );

                    } else {
                        return reject('Sorry! It looks like your browser doesn\'t support Geolocation. You can try using Chrome to utilize this feature.');
                    }
                });
            },

            geocodeKeyword: function (keyword) {
                var getLatLng = function (results) {
                    var gmapsLatLng = _.get(results, '[0].geometry.location') || null;
                    return gmapsLatLng;
                };

                return $q(function (resolve, reject) {
                    if(!google) {
                        reject('Couldn\'t geocode. Google is undefined.');
                    }else {
                        var geocoder = new google.maps.Geocoder();
                        geocoder.geocode({ 'address': keyword }, function (results, status) {
                            if (status == google.maps.GeocoderStatus.OK) {
                                resolve(getLatLng(results));
                            } else {
                                reject('Geocoder failed due to: ' + status);
                            }
                        });
                    }
                });
            },

            reverseGeocodeLatLon: function (lat, lon) {
                var filterResults = function (results) {
                    $log.debug('Geocoder Results: ', results);
                    var foundPlace = function (type) {
                        return _.find(results, function (res) {
                            return (res.types).indexOf(type) > -1;
                        });
                    };

                    var placeFound = null;
                    var foundLocality = foundPlace('locality');
                    var foundZip = foundPlace('postal_code');

                    if(!foundLocality) {
                        if(foundZip) placeFound = foundZip;
                    }else{
                        placeFound = foundLocality;
                    }

                    if(placeFound) {
                        $log.debug('Found Place: ', placeFound.formatted_address);
                    }

                    return placeFound;
                };

                return $q(function (resolve, reject) {
                    if(!google) {
                        reject('Couldn\'t reverse geocode. Google is undefined.');
                    }else {
                        var geocoder = new google.maps.Geocoder();
                        var latlng = new google.maps.LatLng(lat, lon);
                        geocoder.geocode({ 'latLng': latlng }, function (results, status) {
                            if (status == google.maps.GeocoderStatus.OK) {
                                resolve(filterResults(results));
                            } else {
                                reject('Geocoder failed due to: ' + status);
                            }
                        });
                    }
                });
            },

            getDistanceBetweenPoints: function (lat1, lon1, lat2, lon2) {
                // using the Haversine Formula
                var R = 3959; // Radius of the earth in miles
                var deg2rad = function (deg) { return deg * (Math.PI/180); };
                var dLat = deg2rad(lat2-lat1);  // deg2rad below
                var dLon = deg2rad(lon2-lon1);
                var a =
                    Math.sin(dLat/2) * Math.sin(dLat/2) +
                    Math.cos(deg2rad(lat1)) * Math.cos(deg2rad(lat2)) *
                    Math.sin(dLon/2) * Math.sin(dLon/2);

                var c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1-a));
                var d = R * c; // Distance in miles
                return d;
            },

            getHomeSpecs: function (data) {
                var homeSpecs = [];
                var homeSpecsKeys = ['beds', 'baths', 'home_size'];
                var homeSpecsUnits = ['BD', 'BA', 'SQ.FT.'];

                homeSpecsKeys.forEach(function (val, i) {
                    if(!!data && data.hasOwnProperty(val) && !!data[val]){
                        homeSpecs.push($filter('addCommas')(data[val]) + ' ' + homeSpecsUnits[i]);
                    }
                });
                homeSpecs = (homeSpecs.length) ? homeSpecs.join(' | ') : '';
                return homeSpecs;
            },

            getPaginated: function (results, page) {
                page = page || 1;
                var per_page = 50;
                var offset = (page - 1) * per_page;
                var paginatedItems = results.slice(offset, offset + per_page);
                var _this = this;

                return {
                    offset_start: offset + 1,
                    offset_end: offset + paginatedItems.length,
                    page: page,
                    per_page: per_page,
                    total: results.length,
                    total_pages: Math.ceil(results.length / per_page),
                    data: paginatedItems
                };
            },

            displayAsLocalTime: function displayAsLocalTime(dateString) {
                var t;

                if(dateString) {
                    t = new Date(dateString);
                    t = new Date( t.getTime() + ( t.getTimezoneOffset() * 60000 ) );
                    t = t.toISOString();
                }

                return t || null;
            },

            getNextOpenHouse: function (data) {
                var _this = this;
                var nextOpenHouse = null;

                if(data && data.open_houses) {
                    var dateString;
                    var oh = data.open_houses;

                    if(typeof oh === 'string' && moment(oh).isAfter()) {
                        dateString = oh;
                    } else if(typeof oh === 'object' && oh.date && moment(oh.date).isAfter()) {
                        dateString = oh.date;
                    } else if(angular.isArray(oh) && oh.length) {
                        var numOh = oh.length;
                        var i = 0;
                        while(i < numOh) {
                            var aOH = oh[i];
                            if(typeof aOH === 'string' && moment(aOH).isAfter()) {
                                dateString = aOH;
                            } else if(typeof aOH === 'object' && aOH.date && moment(aOH.date).isAfter()) {
                                dateString = aOH.date;
                            }

                            if (dateString) break;
                            i++;
                        }
                    }

                    nextOpenHouse = _this.displayAsLocalTime(dateString);
                }

                return nextOpenHouse;
            },

            getDaysOnMarket: function (data) {
                var dom = null;

                if(data && data.listing_date) {
                    var a = moment();
                    var b = moment(data.listing_date);

                    if(a >= b) {
                        dom = a.diff(b, 'days');
                    }
                }

                return dom;
            },

            getListSortObj: function (parent) {
                var p = parent || '';
                var listSortObj =  {
                    options: [
                        {
                            value: 'MatchScore:desc',
                            title: 'Sort by Match Score'
                        },
                        {
                            value: 'YearBuilt:desc',
                            title: 'Sort by Year Built'
                        },
                        {
                            value: 'ListPrice:desc',
                            title: 'Sort by Price (High to Low)'
                        },
                        {
                            value: 'ListPrice:asc',
                            title: 'Sort by Price (Low to High)'
                        },
                        {
                            value: 'Bedrooms:desc',
                            title: 'Sort by Most Bedrooms'
                        },
                        {
                            value: 'Bathrooms:desc',
                            title: 'Sort by Most Bathrooms'
                        },
                        {
                            value: 'LivingArea:desc',
                            title: 'Sort by Largest SqFt.'
                        },
                        {
                            value: 'OpenHouseDate:asc',
                            title: 'Sort by Open House'
                        },
                        {
                            value: 'ListingDate:asc',
                            title: 'Sort by Days on Market'
                        }
                    ]
                };

                listSortObj.selected = listSortObj.options[0];
                return listSortObj;
            },

            humanizeFilterParams: function (params) {
                var hparams = [];
                var translate = function (param) {
                    var translated = [param.name,param.value].join(' ');
                    switch (param.name){
                        case 'price':
                            translated = ['Around $',$filter('numberAbbreviate')(param.value)].join('');
                            break;

                        case 'whatsimportant':
                            translated = (param.value === 'all')
                                ? false
                                : ['Prefer:', param.value].join(' ');
                            break;

                        case 'schools':
                            translated = (param.value === 'not so much')
                                ? false
                                : ['Schools:', param.value].join(' ');
                            break;

                        case 'hometype':
                            translated = (param.value === 'any')
                                ? false
                                : [param.value, ' Home'].join('');
                            break;

                        case 'bedrooms':
                            translated = [param.value, ' BD'].join('');
                            break;

                        case 'bathrooms':
                            translated = [param.value, ' BA'].join('');
                            break;

                        case 'age':
                            translated = [param.value, ' Yrs Old'].join('');
                            break;

                        case 'stories':
                            translated = [param.value, (param.value == '1') ? ' Story' : ' Stories'].join('');
                            break;

                        case 'sqfeet':
                            translated = [param.value, ' Sq. Ft.'].join('');
                            break;

                        case 'lotsize':
                            translated = [param.value, ' Lot'].join('');
                            break;

                        case 'keywords':
                            translated = ['Keywords: ', param.value.join(', ')].join('');
                            break;

                        default:
                            translated = false;
                            break;
                    }

                    return translated;
                };

                if(params && angular.isArray(params) && params.length > 0) {
                    hparams = params.filter(translate).map(translate);
                }

                return hparams;
            },

            filterOutsideStandardDeviation: function (data, correctionMultiplier) {
                var getAverage = function getAverage(data) {
                    var sum = data.reduce(function(sum, value) {
                        return sum + value;
                    }, 0);
                    var avg = sum / data.length;
                    return avg;
                };

                var latValues = data.map(function (r){ return r.lat; });
                var averageLat = getAverage(latValues);
                var squareDiffsLat = latValues.map(function(value, i) {
                    var diff = value - averageLat;
                    var sqrDiff = diff * diff;
                    return sqrDiff;
                });

                var lonValues = data.map(function (r){ return r.lon; });
                var averageLon = getAverage(lonValues);
                var squareDiffsLon = lonValues.map(function(value, i) {
                    var diff = value - averageLon;
                    var sqrDiff = diff * diff;
                    return sqrDiff;
                });

                var avgSquareDiffLat = getAverage(squareDiffsLat);
                var avgSquareDiffLon = getAverage(squareDiffsLon);

                var stdDeviationLat = Math.sqrt(avgSquareDiffLat);
                var stdDeviationLon = Math.sqrt(avgSquareDiffLon);
                var stdDeviationLatCorrected = stdDeviationLat * correctionMultiplier;
                var stdDeviationLonCorrected = stdDeviationLon * correctionMultiplier;

                // $log.debug('Standard Deviation Lat is ', stdDeviationLat, '| Corrected:', stdDeviationLatCorrected);
                // $log.debug('Standard Deviation Lon is ', stdDeviationLon, '| Corrected:', stdDeviationLonCorrected);

                var filteredData1 = data.filter(function(doc) {
                    var absDiff = Math.abs(doc.lat - averageLat);
                    // $log.debug('Diff [lat]', doc.id, 'is', absDiff, '|', (absDiff > stdDeviationLatCorrected) ? 'invalid' : 'valid');
                    return absDiff <= stdDeviationLatCorrected;
                });

                var filteredData2 = filteredData1.filter(function(doc) {
                    var absDiff = Math.abs(doc.lon - averageLon);
                    // $log.debug('Diff [lon]', doc.id, 'is', absDiff, '|', (absDiff > stdDeviationLonCorrected) ? 'invalid' : 'valid');
                    return absDiff <= stdDeviationLonCorrected;
                });

                return filteredData2;
            }
        };
    }
]);
